// JobOffer.jsx
import React from 'react';

const JobOffer = ({ title, link, date }) => {
  return (
    <div style={jobOfferStyle}>
      <h3 style={titleStyle}>
        <a href={link} target="_blank" rel="noopener noreferrer" style={linkStyle}>
          {title}
        </a>
      </h3>
      <p style={dateStyle}>{date}</p>
    </div>
  );
};

// Styles
const jobOfferStyle = {
  border: '1px solid #ddd',
  borderRadius: '8px',
  padding: '30px',
  margin: '15px 0',
  backgroundColor: '#ffffff',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  width: '80%',
  maxWidth: '600px',
  position: 'relative',
};

const titleStyle = {
  fontSize: '1.8rem',
  color: '#49796B', // Blue color
  margin: '0 0 10px',
  textDecoration: 'underline', // Underline for clickable appearance
  fontFamily: 'Verdana, Geneva, sans-serif', // Font for links
};

const linkStyle = {
  textDecoration: 'none', // Remove default underline from link
  color: '#49796B', // Blue color
  cursor: 'pointer' // Pointer cursor to indicate clickability
   // Make the link text bold
};

const dateStyle = {
  fontSize: '1rem',
  color: '#888', // Gray color
  marginTop: '10px',
  textAlign: 'right',
  position: 'absolute',
  bottom: '10px',
  right: '10px',
};

export default JobOffer;
